<template>
	<div>
		<!-- 用户端 -->
		<ul v-if='role=="user"'>
			<!-- 待付款，已取消 -->
			<li v-if="detailList.order_status==1 || detailList.order_status==7">
				<div class="status-wrap left" :class='detailList.order_status!=7?"no-r":""'>
					<div :class='detailList.order_status==1?"bg":""'></div>
					<p :class='detailList.order_status==1?"cl":""'>待付款</p>
				</div>
				<div class="jian-ge" v-if="detailList.order_status==7"></div>
				<div class="status-wrap" v-if="detailList.order_status==7">
					<div class='bg level'></div>
					<p class='cl'>已取消</p>
				</div>
			</li>
			
			<!-- 待处理 处理中 -->
			<li v-if="detailList.order_status==2 || detailList.order_status==3 || detailList.order_status==13">
				<div class="status-wrap left" v-if='detailList.order_status==13'>
					<div></div>
					<p>待处理</p>
				</div>
				
				<div class="status-wrap left" v-else>
					<div></div>
					<p>已付款</p>
				</div>
				
				<div class="jian-ge"></div>
				<div class="status-wrap">
					<div class="bg level"></div>
					<p class="cl">处理中</p>
				</div>
			</li>
			
			<!-- 待确认 已撤回 未解决 退款中-->
			<li v-if="detailList.order_status==4 || detailList.order_status==11 || detailList.order_status==10">
				<div class="status-wrap left">
					<div></div>
					<p>已付款</p>
				</div>
				<div class="jian-ge-2"></div>
				<div class="status-wrap left">
					<div></div>
					<p>处理中</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==4">
					<div class="bg level"></div>
					<p class="cl">待确认</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==11">
					<div class="bg level"></div>
					<p class="cl">未解决</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==10">
					<div class="bg level"></div>
					<p class="cl">退款中</p>
				</div>
			</li>
			
			
			<!-- 已成功  已退款 已驳回 -->
			<li v-if="detailList.order_status==5 || detailList.order_status==8 || detailList.order_status==9">
				<div class="status-wrap left">
					<div></div>
					<p>已付款</p>
				</div>
				<div class="jian-ge-3"></div>
				<div class="status-wrap left">
					<div></div>
					<p>处理中</p>
				</div>
				<div class="status-wrap left" v-if="detailList.order_status==9">
					<div></div>
					<p>退款中</p>
				</div>
				<div class="status-wrap left" v-else>
					<div></div>
					<p>待确认</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==5">
					<div class="bg level"></div>
					<p class="cl">已完成</p>
				</div>
				
				<div class="status-wrap" v-if="detailList.order_status==8">
					<div class="bg level"></div>
					<p class="cl">已驳回</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==9">
					<div class="bg level"></div>
					<p class="cl">已退款</p>
				</div>
			</li>
		</ul>
		
		<!-- 业务员端 管理员端 -->
		<ul v-if='role=="sale" || role=="admin"'>
			<!-- 待处理 处理中 -->
			<li v-if="detailList.order_status==2 || detailList.order_status==3">
				<div class="status-wrap left" :class='detailList.order_status!=3?"no-r":""'>
					<div :class='detailList.order_status==2?"bg":""'></div>
					<p :class='detailList.order_status==2?"cl":""'>待处理</p>
				</div>
				<div class="jian-ge" v-if="detailList.order_status==3"></div>
				<div class="status-wrap" v-if="detailList.order_status==3">
					<div class='bg level'></div>
					<p class='cl'>处理中</p>
				</div>
			</li>
			
			<!-- 待确认 已撤回  管理员端的未解决，退款中-->
			<li v-if="detailList.order_status==4 || detailList.order_status==6  || detailList.order_status==10 || detailList.order_status==11 || detailList.order_status==13">
				<div class="status-wrap left">
					<div></div>
					<p >待处理</p>
				</div>
				<div class="jian-ge-2"></div>
				<div class="status-wrap left">
					<div></div>
					<p>处理中</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==4">
					<div class='bg level'></div>
					<p class='cl'>待确认</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==6 || detailList.order_status==13">
					<div class='bg level'></div>
					<p class='cl'>已撤回</p>
				</div>
				<div class="status-wrap" v-if='detailList.order_status==11 && role=="admin"'>
					<div class='bg level'></div>
					<p class='cl'>未解决</p>
				</div>
                <div class="status-wrap" v-if='detailList.order_status==11 && role=="sale"'>
                	<div class='bg level'></div>
                	<p class='cl'>已关闭</p>
                </div>
				<div class="status-wrap" v-if='detailList.order_status==10'>
					<div class='bg level'></div>
					<p class='cl'>退款中</p>
				</div>
			</li>
			
			
			<!-- 已成功 已驳回 已关闭 -->
			<li v-show="detailList.order_status==5 || detailList.order_status==8 || detailList.order_status==9">
				<div class="status-wrap left">
					<div></div>
					<p >待处理</p>
				</div>
				
				<div class="jian-ge-3"></div>
				
				<div class="status-wrap left">
					<div></div>
					<p>处理中</p>
				</div>
				
				<div class="status-wrap left" v-if='detailList.order_status==9 && role=="sale"'>
					<div></div>
					<p>已撤回</p>
				</div>
				
				<div class="status-wrap left" v-else-if='detailList.order_status==9 && role=="admin"'>
					<div></div>
					<p>退款中</p>
				</div>
				
				<div class="status-wrap left" v-else>
					<div></div>
					<p>待确认</p>
				</div>

				<div class="status-wrap" v-if="detailList.order_status==5">
					<div class='bg level'></div>
					<p class='cl'>已完成</p>
				</div>
				<div class="status-wrap" v-if="detailList.order_status==8">
					<div class='bg level'></div>
					<p class='cl'>已驳回</p>
				</div>
				<div class="status-wrap" v-if='detailList.order_status==9 && role=="sale"'>
					<div class='bg level'></div>
					<p class='cl'>已关闭</p>
				</div>
				<div class="status-wrap" v-if='detailList.order_status==9 && role=="admin"'>
					<div class='bg level'></div>
					<p class='cl'>已退款</p>
				</div>
			</li>
		</ul>
		
	</div>
</template>

<script>
    export default {
		props:{
			detailList:{
				type: Object
			},
			
			role:{
				type: String
			}
		}
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	ul{font-family:PingFangSC-Regular,PingFang SC;;font-weight:400;background:rgba(255,255,255,1);}
	li{position: relative;display: flex;align-items: center;justify-content: center;width:355px;height: 72px;margin-bottom: 10px;}
	li .status-wrap{display: flex;flex-direction: column;align-items: center;}
	li .status-wrap div{width:10px;height:10px;border-radius: 50%;background:#DDDDDD;margin-bottom: 12px}
	li .status-wrap p{font-size:12px;color:#666666;}
	li .status-wrap .bg{background:#108EE9;}
	li .status-wrap .cl{color:#4184F4;}
	.jian-ge{position: absolute;top: 28%;width: 76px;height: 2px;background: #DDDDDD}
	.jian-ge-2{position: absolute;top: 28%;left:30%;width: 140px;height: 2px;background: #DDDDDD}
	.jian-ge-3{position: absolute;top: 28%;left:22%;width: 198px;height: 2px;background: #DDDDDD}
	.left{margin-right: 30px; z-index: 10;}
	.no-r{margin-right: 0px}
	.level{z-index: 10;}
</style>
